export interface ItemInCartResponse {
  isTrial?: boolean
  itemId: string
  itemSkuCode: string
  name: string
  quantity: number
  priceWithTax?: number
  priceWithoutTax?: number
  size?: number
}

export interface ItemCartSummary {
  items: ItemInCartResponse[]
  totalPrice: number
  totalTax: number
  deliveryFee: number
}

// カート表示用インターフェース
export interface CartDisplayItem {
  standardCartItemData: ItemCartSummary
  regularCartItemData: ItemCartSummary
  totalPrice: number
  purchasedTrialItemIds: string[]
  deliveryType: number
  deliveryFee: number
  totalSize: number
}

export interface CartItemEditParams {
  'item.code'?: string
  'item.skus.code': string
  order_quantity: number
  'item.skus.sell_price_tax_included'?: number
  force_sell_price?: boolean
}

export interface CartItem {
  'item.id': string
  'item.skus.id': string
  sell_price_tax_included: string
  order_quantity: number
  itemName: string
  itemThumbImg: string
  sku_maximum_purchase: number
  sku_minimum_purchase: number
  itemVariationName: []
  imteSkuVariation: []
  item: SelectItem
}

export interface SelectItem {
  item: {
    id: string
  }
  id: string
  code: string
  name: string
  name_read: string
  content1: string
  content2: string
  categories: {
    id: number
    code: string
    name: string
  }[]
  tax_rate_sell_price: number
  tax_rate_regular_price: number
  display_period_begin: string
  display_period_end: any
  purchase_period_begin: string
  purchase_period_end: string
  sku_maximum_purchase: number
  sku_minimum_purchase: number
  disabled_notify_arrival_sku: boolean
  images: {
    url: string
    alt_text: string
  }[]
  variation: {
    id: string
    code: string
    name: string
  }[]
  custom: { [customAttr: string]: number | string | any }
  created_at: string
  updated_at: string
  skus: SelectItemSku
}

export interface SelectItemSku {
  id: string
  code: string
  variation: {
    id: string
    code: string
    name: string
  }
  jan: string
  sell_price_tax_included: number
  sell_price_tax_excluded: number
  regular_price_tax_included: number
  regular_price_tax_excluded: number
  stock_quantity_infinity: boolean // 在庫無制限の場合: 1
  stock_quantity: number
  images: Image2[]
  coupon_ids: string[]
  basic_point_amount: number
  custom: { [customAttr: string]: number | string | any }
  sku_maximum_purchase: number
  sku_minimum_purchase: number
}

export interface Image2 {
  url: string
  alt_text: string
  code: string
  sortkey: number
}

/**
 * UserItemReviewFields
 */
export const CartFields = [
  'item.id',
  'item.name',
  'item.images',
  'item.variation',
  'item.skus.id',
  'item.skus.code',
  'item.skus.stock_quantity',
  'item.skus.sell_price_tax_included',
  'item.skus.variation',
  'item.skus.variation.id',
  'item.skus.variation.code',
  'item.skus.variation.name',
  'item.skus.custom.trial_flg',
  'item.purchase_period_begin',
  'item.purchase_period_end',
  'item.sku_maximum_purchase',
  'item.sku_minimum_purchase',
  'order_quantity',
  'force_sell_price',
  'sell_price_tax_included',
]

export const ITEM_TYPE = {
  STANDARD: '0',
  REGULAR: '1',
} as const

export const DELIVERY_TYPE = {
  MAIL: 0,
  DELIVERY: 1,
} as const

/**
 * 決済方法
 */
export const PAYMENT_METHOD = {
  // 口座振替
  DirectDebit: 1,
  // クレジットカード
  CreditCard: 2,
  // 代金引換
  CashOnDelivery: 3,
  // NP後払い
  NP: 4,
} as const

/**
 * クラウドECの決済方法コード
 */
export const PaymentMethodCd = {
  [PAYMENT_METHOD.CashOnDelivery]: 'PAY-102',
  [PAYMENT_METHOD.CreditCard]: 'PAY-100',
  [PAYMENT_METHOD.NP]: 'PAY-104',
  [PAYMENT_METHOD.DirectDebit]: 'PAY-106',
} as const
